import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import isRune from '@/utils/is-rune'

export default function useRuneStats(slug: string) {
	return useSwr(isRune(slug) ? `${API_URL}/rune/${slug.split('-')[1]}/stats` : null, fetcher)
}
